module.exports = __webpack_public_path__ + "static/media/map-mav-bar-expand-close.51771866.svg";